import React, { useState } from 'react'
import 'react-dates/initialize'
import { DayPickerSingleDateController } from 'react-dates'
import moment from 'moment'
import styled from 'styled-components'

import { isInclusivelyAfterDay } from '../../../utils/dates'

const OpenedCalendar = ({ startDate, handleDatesChange }) => {
  const [focused, setFocused] = useState(false)
  return (
    <Content>
      <DayPickerSingleDateController
        date={moment(startDate)}
        onDateChange={days => handleDatesChange(days)}
        focused={focused}
        onFocusChange={({ focused }) => setFocused(focused)}
        noBorder
        id='startDate'
        numberOfMonths={1}
        hideKeyboardShortcutsPanel
        isOutsideRange={days => !isInclusivelyAfterDay(days, moment())}
        weekDayFormat='ddd'
      />
    </Content>
  )
}

const Content = styled.div`
  .CalendarDay {
    border: none;
  }

  .CalendarDay__selected {
    background: #ff7708;
    border-radius: 50%;
  }

  .CalendarDay__default {
    &:hover {
      border-radius: 50%;
    }
  }

  .CalendarMonth_caption {
    text-align: left;
    margin-left: 12px;
  }

  .DayPickerNavigation_rightButton__horizontalDefault {
    background: url('/static/images/chevronRight.svg') no-repeat;
    border: none;
    margin-top: 9px;
    svg {
      display: none;
    }
    &:hover {
      outline: none;
    }
  }

  .DayPickerNavigation_leftButton__horizontalDefault {
    background: url('/static/images/chevronLeft.svg') no-repeat;
    border: none;
    margin-top: 9px;
    right: 60px;
    left: auto;
    svg {
      display: none;
    }
    &:hover {
      outline: none;
    }
  }

  .DayPickerNavigation_button__default,
  .DayPickerNavigation_button__default {
    &:hover,
    &:focus,
    &:active {
      background-color: transparent;
      border: none;
    }
  }
`

export { OpenedCalendar }
